import React from "react";
import { statusText, statusTone } from "./shipmentMarkers";
import { driverActivityAlert } from "./driverActivity";
import { formatMinutes } from "./towerFormat";
import type { RouteStop } from "./driverRoute";

// "Ver orden de recorrido": las visitas de hoy en el orden en que se
// registraron, con el tiempo desde la anterior (amarillo y rojo: los mismos
// umbrales que la alerta de inactividad).
export default function DriverRouteTable({ stops }: { stops: RouteStop[] }) {
  return (
    <div className="tower-table-scroll tower-route-list">
      <table className="tower-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Hora</th>
            <th title="Tiempo entre esta visita y la anterior. Amarillo y rojo: mismos umbrales que la alerta de inactividad.">
              Desde la anterior
            </th>
            <th>Cliente / tracking</th>
            <th>Destino</th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          {stops.map((stop) => {
            const gapLevel = stop.gapMinutes === null ? null : driverActivityAlert(stop.gapMinutes);
            return (
              <tr key={stop.shipment.id}>
                <td>
                  <span className={`tower-route-order ${stop.shipment.status}`}>{stop.order}</span>
                </td>
                <td>{stop.time}</td>
                <td>
                  {stop.gapMinutes === null ? (
                    "Primera visita"
                  ) : (
                    <span className={gapLevel ? `tower-route-gap ${gapLevel}` : undefined}>
                      {formatMinutes(stop.gapMinutes)}
                    </span>
                  )}
                </td>
                <td>
                  <strong className="tower-client">{stop.shipment.client}</strong>
                  <small>{stop.shipment.tracking}</small>
                </td>
                <td>
                  {stop.shipment.address || "Sin dirección"}
                  <small>{stop.shipment.locality || "Sin localidad"}</small>
                </td>
                <td>
                  <span className={`tower-state ${statusTone(stop.shipment)}`}>{statusText(stop.shipment)}</span>
                  <small>{stop.shipment.rawStatus}</small>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
